import { clearTrialData, preserveTrialData } from '@/utils/trialUtils';
import { logActivity } from '@/utils/security/activityLogger';
import { useToast } from '@/hooks/use-toast';
import { useNavigate } from 'react-router-dom';

export const useTrialTermination = () => {
  const { toast } = useToast();
  const navigate = useNavigate();

  const terminateTrial = async () => {
    try {
      // Preserve trial data before termination
      const preservedData = await preserveTrialData();
      
      // Log termination activity
      await logActivity({
        action_type: 'TRIAL_TERMINATION',
        resource_type: 'trial',
        details: { preservedData },
        phi_accessed: false
      });

      // Clear trial data
      clearTrialData();

      toast({
        title: "Trial Terminated",
        description: "Your trial has been terminated. Thank you for trying our service.",
        duration: 5000,
      });

      // Redirect to subscription page
      navigate('/subscription');
    } catch (error) {
      console.error('Error during trial termination:', error);
      toast({
        title: "Termination Error",
        description: "There was an error terminating your trial. Please try again.",
        variant: "destructive",
      });
    }
  };

  return { terminateTrial };
};